// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"98b85fa5","239":"72b5db6d","283":"a977b918","301":"2513d91f","453":"83cf7713","553":"63efb0cb"}[chunkId] + ".chunk.js";
};